import { getPopupStore } from './PopupController';

type ButtonPopupPayload = {
    type: 'content';
    content: string;
};

const BUTTON_SELECTOR = '[data-uu-button-action="custom"][data-uu-button-popup]';
const CONTENT_SELECTOR = '[data-uu-button-popup-content]';

const findPopupContentSource = (popupId: string): HTMLElement | null => {
    const sources = Array.from(document.querySelectorAll<HTMLElement>(CONTENT_SELECTOR));

    return sources.find((source) => source.dataset.uuButtonPopupContent === popupId) || null;
};

const openButtonPopup = (popupId: string): void => {
    const source = findPopupContentSource(popupId);

    if (!source) {
        return;
    }

    getPopupStore().open(popupId, {
        type: 'content',
        content: source.innerHTML,
    } satisfies ButtonPopupPayload as unknown as Record<string, unknown>);
};

const handleButtonPopupClick = (event: Event): void => {
    const target = event.target;

    if (!(target instanceof HTMLElement)) {
        return;
    }

    const trigger = target.closest(BUTTON_SELECTOR);

    if (!(trigger instanceof HTMLElement)) {
        return;
    }

    const popupId = trigger.dataset.uuButtonPopup;

    if (!popupId) {
        return;
    }

    event.preventDefault();
    openButtonPopup(popupId);
};

const initButtonPopups = (): void => {
    document.addEventListener('click', handleButtonPopupClick);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtonPopups, { once: true });
} else {
    initButtonPopups();
}